import { Pipe, PipeTransform } from '@angular/core';
import type { PropertyItemWithDepth } from '../product-tree.selectors';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'productTreeOrderByName',
  standalone: false
})
export class ProductTreeOrderByNameAndDepthPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: PropertyItemWithDepth[]): PropertyItemWithDepth[] {
    if (!value || !value.length) {
      return [];
    }

    const sorted = [...value];

    sorted.sort((a, b) => {
      // If A is higher in the hierarchy than B, it should come before B
      if (a.depth < b.depth) {
        return -1;
      }
      if (a.depth > b.depth) {
        return 1;
      }

      const aName = this.translateService.instant(a.item.NameId);
      const bName = this.translateService.instant(b.item.NameId);

      if (aName < bName) {
        return -1;
      } else if (aName > bName) {
        return 1;
      } else {
        return 0;
      }
    });

    return sorted;
  }
}
